import {
  EditGuesser,
  FieldGuesser,
  InputGuesser,
  ListGuesser,
} from "@api-platform/admin";
import { ReferenceArrayInput, SelectArrayInput } from "react-admin";
import { JsonInput } from "react-admin-json-view";
import TextInputStyle from "../style/TextInputStyle";

const CableInsulationList = (props: any) => (
  <ListGuesser {...props}>
    <FieldGuesser source={"name"} />
    <FieldGuesser source={"title"} />
    <FieldGuesser source={"sortIndex"} />
  </ListGuesser>
);

const CableInsulationEdit = (props: any) => (
  <EditGuesser {...props}>
    <InputGuesser source={"name"} />
    <InputGuesser source={"title"} />
    <InputGuesser source={"description"} />
    <InputGuesser style={TextInputStyle} source={"sortIndex"} />

    <ReferenceArrayInput
      source="fireHazardClasses"
      reference="cable_fire_hazard_classes"
    >
      <SelectArrayInput optionText="title" />
    </ReferenceArrayInput>
    <ReferenceArrayInput
      source="climaticVersions"
      reference="cable_climatic_versions"
    >
      <SelectArrayInput optionText="title" />
    </ReferenceArrayInput>

    <JsonInput
      source={"textGenVars"}
      reactJsonOptions={{
        name: null,
        displayDataTypes: false,
        displayObjectSize: false,
        enableClipboard: false,
        onAdd: () => {},
      }}
    />
    <JsonInput
      source={"modelVars"}
      reactJsonOptions={{
        name: null,
        displayDataTypes: false,
        displayObjectSize: false,
        enableClipboard: false,
        defaultValue: "",
        onAdd: () => {},
      }}
    />
  </EditGuesser>
);

export { CableInsulationList, CableInsulationEdit };
